import { memo, Suspense } from 'react';
import type { RecommendationRequestWrapper } from 'autogen/swagger/all';
import dynamic from 'helpers/dynamic';
import useRecommendationModelAsync from '../shared/hooks/useRecommendationModelAsync';
import type { ProductRecommendationProps } from '../shared/types';

const ProductRecommendation = dynamic(() => import('../ProductRecommendation'), {
    ssr: false
});

const RecommendationLoader = ({
    model,
    ...restProps
}: {
    model: RecommendationRequestWrapper['recommendationRequest'];
} & Omit<ProductRecommendationProps, 'model'>) => {
    const { data: resolvedModel, isLoading } = useRecommendationModelAsync(model);

    if (!resolvedModel || isLoading) return null;

    // TODO: Add a skeleton loader here - https://hesehus-jira.atlassian.net/browse/MATASS-18607
    return (
        <Suspense fallback={null}>
            <ProductRecommendation {...restProps} model={resolvedModel} />
        </Suspense>
    );
};

export default memo(RecommendationLoader);
